import { render, staticRenderFns } from "./data_detail.vue?vue&type=template&id=4cd9b64e&scoped=true"
import script from "./data_detail.vue?vue&type=script&lang=ts"
export * from "./data_detail.vue?vue&type=script&lang=ts"
import style0 from "./data_detail.vue?vue&type=style&index=0&id=4cd9b64e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd9b64e",
  null
  
)

export default component.exports